import { useMarketplaceItemDetail } from '@/apis/marketplace/hooks/useMarketplaceItemDetails'
import { MarketplaceItem } from '@/apis/marketplace/marketplace.schema'
import MultiQueryPageLoader from '@/app/common/components/PageLoader/MultiQueryPageLoader'
import {
  addToCart,
  setCartAnimation,
  resetCartAnimation,
} from '@/storage/applications/marketplaceCartSlice'
import { selectProgramSettings } from '@/storage/program_settings/programSettingsSlice'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ItemDetailUI } from '../components/ItemDetailUI'

const ItemDetailPage = () => {
  const [buttonAnimated, setButtonAnimated] = useState(false)

  // this is obviously not great. I need to fix this.
  const queryId = location.pathname.split('/')[2] ?? 0
  const [searchParams] = useSearchParams()

  const itemId = parseInt(queryId)
  const thirdPartyItemId = searchParams.get('third_party_item_id')
    ? parseInt(searchParams.get('third_party_item_id')!)
    : undefined
  const query = useMarketplaceItemDetail(itemId, thirdPartyItemId)
  const navigate = useNavigate()
  const programSettings = useSelector(selectProgramSettings)

  const dispatch = useDispatch()

  useEffect(() => {
    if (programSettings.marketplace_module == 0) navigate(-1)
  }, [navigate])

  const handleAddToCart = (item: MarketplaceItem) => {
    const effectiveName = item.third_party_item?.custom_name ?? item.name
    const effectivePrice =
      item.third_party_item?.custom_price &&
      !isNaN(parseFloat(item.third_party_item.custom_price))
        ? parseFloat(item.third_party_item.custom_price)
        : item.price
    const cartKey = `${item.id}:${item.third_party_item?.id ?? 'null'}`
    dispatch(
      addToCart({
        cartKey,
        quantity: 1,
        id: item.id,
        name: effectiveName,
        price: effectivePrice,
        third_party_item_id: item.third_party_item?.id ?? null,
      })
    )
    dispatch(setCartAnimation())
    setTimeout(() => dispatch(resetCartAnimation()), 500)

    setButtonAnimated(true)
    setTimeout(() => setButtonAnimated(false), 1000)
  }

  const goBack = () => {
    navigate(-1)
  }

  return (
    <MultiQueryPageLoader queries={[query] as const}>
      {([data]) => {
        return (
          <ItemDetailUI
            data={data}
            onGoBack={goBack}
            onAddToCart={handleAddToCart}
            buttonAnimated={buttonAnimated}
          />
        )
      }}
    </MultiQueryPageLoader>
  )
}

export default ItemDetailPage
